import { useState, useEffect } from 'react';
import { useNotificationProvider } from 'hooks';
import getEmployees from 'api/timesheets/getEmployees';
import { useSelector } from 'react-redux';
import { selectUserInfo } from 'redux/userInfo/userInfoSlice';
import { isEmployee } from '../utils/typeChecker';
import { Employee } from '../types/employee';

const useEmployeeData = () => {
	const { userInfo } = useSelector(selectUserInfo);
	const [employees, setEmployees] = useState<Employee[]>([]);
	const [selectedEmployee, setSelectedEmployee] = useState<Employee | null>(
		null,
	);
	const [loadingEmployees, setLoadingEmployees] = useState<boolean>(false);
	const { notifyError, notifySuccess } = useNotificationProvider();

	const fetchEmployees = async () => {
		try {
			setLoadingEmployees(true);
			const data: any = await getEmployees();
			if (Array.isArray(data) && data.every(isEmployee)) {
				// const filteredData = data.filter(
				// 	(employee) => !employee.FullName.startsWith('ZZ '),
				// ); // Full name shouldn't start with ZZ. These are test users from back in the day
				// // sort by full name
				// TODO: change data.sort to filteredData.sort once the filtering is uncommented
				data.sort((a, b) => a.FullName.localeCompare(b.FullName));
				setEmployees(data);
			} else {
				throw new Error('Error converting employees data');
			}
		} catch (e) {
			console.error(e);
			notifyError('Failed to fetch consultants');
		} finally {
			setLoadingEmployees(false);
		}
	};

	useEffect(() => {
		const activeEmployee = employees.find(
			(employee) => employee.Id === userInfo?.employeeId,
		);
		if (activeEmployee) {
			setSelectedEmployee(activeEmployee);
		} else {
			setSelectedEmployee(null);
		}
	}, [employees, userInfo]);

	useEffect(() => {
		fetchEmployees();
	}, []);
	return {
		employees,
		selectedEmployee,
		loadingEmployees,
		setSelectedEmployee,
	};
};

export default useEmployeeData;
